export default "__VITE_ASSET__vK4s8fs0__"